import apiClient from "./http";
import { FEATURES } from "../config/features";

const guard = () => {
  if (!FEATURES.ADMIN_MODULE) {
    return Promise.reject(new Error("ADMIN_MODULE_DISABLED"));
  }
  return null;
};

export const getRulesVersions = () => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.get("/Rules/versions");
};

export const getAnalyticsOverview = () => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.get("/Analytics/overview");
};

export const getAdminUsers = (params) => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.get("/admin/users", { params });
};

export const getAdminUserDetail = (id) => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.get(`/admin/users/${id}`);
};

export const getAdminBillingTransactions = (params) => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.get("/admin/billing/transactions", { params });
};

export const getAdminBillingTransactionDetail = (id) => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.get(`/admin/billing/transactions/${id}`);
};

export const approveAdminBilling = (payload, idempotencyKey) => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.post("/admin/billing/approve", payload, {
    headers: {
      "Idempotency-Key": idempotencyKey,
    },
  });
};

export const getAdminReportsStatus = (params) => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.get("/admin/reports/status", { params });
};

export const getAdminAnalysisErrors = (params) => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.get("/admin/analysis/errors", { params });
};

export const getAdminEntityList = (entity, params) => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.get(`/admin/${entity}`, { params });
};

export const createAdminEntity = (entity, payload) => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.post(`/admin/${entity}`, payload);
};

export const updateAdminEntity = (entity, id, payload) => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.put(`/admin/${entity}/${id}`, payload);
};

export const deleteAdminEntity = (entity, id) => {
  const blocked = guard();
  if (blocked) return blocked;
  return apiClient.delete(`/admin/${entity}/${id}`);
};